/**
 * redirects from hellblazer to dasher:
 *
 *  -> https://github.com/stitchfix/hellblazer/blob/8976f1bd1d0545481df79d627e1a6988cea87359/config/routes.rb#L21
 *  -> https://github.com/stitchfix/hellblazer/blob/8976f1bd1d0545481df79d627e1a6988cea87359/app/controllers/style_controller.rb#L48
 *  -> https://github.com/stitchfix/hellblazer/blob/8976f1bd1d0545481df79d627e1a6988cea87359/config/routes.rb#L185
 *  -> https://github.com/stitchfix/dasher/blob/ec03e58058f6cc0f4e2b189eb467d6637be66bc6/config/routes.rb#L15
 */
export const ONBOARDING_START_PATH = '/welcome/style';

export const POST_ONBOARDING_PATH = '/fix-home';

export const DOWNLOAD_APP_PATH = '/onboarding/download-app/';

export const STYLEFILE_PATH = '/onboarding/stylefile';

export const VISION_PATH = '/onboarding/vision';

export const PROFILE_NOTE_PATH = '/onboarding/profile-note';

export const HOME_FEED_PATH = '/home';
